import type { QueryResult, WidgetData } from "../types/data";

export function unwrap<T>(result: QueryResult | undefined): T | null {
  if (!result || result.isLoading || result.error || result.data === null) {
    return null;
  }

  return result.data as T;
}

export function firstError(data: WidgetData, dataKeys: string[]): Error | null {
  for (const dataKey of dataKeys) {
    const result = data[dataKey];

    if (result?.error) {
      return result.error;
    }
  }

  return null;
}
